export default {
  name: 'VVoid',
  render (h) {
    return h()
  }
}
